import { Grid, useEventCallback } from '@mui/material';
import { Fragment, memo, useMemo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import { DatePicker } from '@mui/lab';
import { ConfigurationType } from 'civil-status/constants/configuration-type';
import ListTemplateTranscription, { ItemTemplateVM } from '../list/list-template-transcription';
import FormTratxtBase from '../transcription-data/form-tratxt-base';

interface ResultVerificationMayorProps {
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  configuration?: string;
  tipoEvento?: string;
  idEvento?: number;
  disabled?: boolean;
}

const ResultVerificationMayorComponent = ({
  onChange,
  onChanges,
  values,
  errors,
  touched,
  configuration,
  tipoEvento,
  idEvento,
  disabled = false,
}: ResultVerificationMayorProps): React.ReactElement => {
  const isEsiacsi2 = useMemo(() => {
    return configuration === ConfigurationType.ESIACSI2;
  }, [configuration]);

  const handleListTemplateTranscriptionChange = useEventCallback((value?: ItemTemplateVM) => {
    onChanges({
      ...(values || {}),
      templateTranscription2: value?.id?.toString(),
      assessmentResult: value?.valueTemplate || '',
    });
  });

  return (
    <Grid container spacing={2} item>
      {isEsiacsi2 ? (
        <Fragment>
          <Grid item xs={12} md={4}>
            <DatePicker
              label="Data efficacia del provvedimento straniero"
              aria-label="Data efficacia del provvedimento straniero"
              value={values?.dateEffectiveMeasure || null}
              onChange={(date) => {
                onChange('dateEffectiveMeasure', date);
              }}
              disabled={disabled}
              renderInput={(params) => (
                <PmiTextField
                  {...params}
                  id="dateEffectiveMeasure"
                  fullWidth
                  helperText={errors?.dateEffectiveMeasure}
                  error={touched?.dateEffectiveMeasure && Boolean(errors?.dateEffectiveMeasure)}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <PmiTextField
              label="Numero protocollo"
              aria-label="Numero protocollo"
              id="protocolNumber"
              name="protocolNumber"
              fullWidth
              type="text"
              variant="outlined"
              value={values?.protocolNumber || ''}
              onChange={(event) => {
                onChange('protocolNumber', event.target.value);
              }}
              error={touched?.protocolNumber && Boolean(errors?.protocolNumber)}
              helperText={errors?.protocolNumber}
              disabled={disabled}
            />
          </Grid>
        </Fragment>
      ) : undefined}
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data provvedimento Sindaco *"
          aria-label="Data provvedimento Sindaco"
          value={values?.dateMeasureMayor || null}
          onChange={(date) => {
            onChange('dateMeasureMayor', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateMeasureMayor"
              fullWidth
              helperText={errors?.dateMeasureMayor}
              error={touched?.dateMeasureMayor && Boolean(errors?.dateMeasureMayor)}
            />
          )}
        />
      </Grid>
      {isEsiacsi2 ? (
        <Grid item xs={12}>
          <ListTemplateTranscription
            label="Template di accertamento"
            value={values?.templateTranscription2 || ''}
            onChange={handleListTemplateTranscriptionChange}
            idEvento={idEvento}
            tipoEvento={tipoEvento}
            disabled={disabled}
            error={Boolean(errors?.templateTranscription2) && touched?.templateTranscription2}
            idDominio="106"
          />
        </Grid>
      ) : undefined}
      <Grid item xs={12}>
        <PmiTextField
          label="Riassunto esito di accertamento *"
          aria-label="Riassunto esito di accertamento"
          id="assessmentResult"
          name="assessmentResult"
          fullWidth
          type="text"
          variant="outlined"
          multiline
          rows={5}
          value={values?.assessmentResult || ''}
          onChange={(event) => {
            onChange('assessmentResult', event.target.value);
          }}
          error={touched?.assessmentResult && Boolean(errors?.assessmentResult)}
          helperText={errors?.assessmentResult}
          disabled={disabled}
        />
      </Grid>
      {isEsiacsi2 ? (
        <FormTratxtBase
          onChange={onChange}
          onChanges={onChanges}
          values={values}
          errors={errors}
          touched={touched}
          tipoEvento={tipoEvento}
          idEvento={idEvento}
          disabled={disabled}
        />
      ) : undefined}
    </Grid>
  );
};

ResultVerificationMayorComponent.displayName = 'Form Result Verification Mayor component';

const ResultVerificationMayor = memo(ResultVerificationMayorComponent);

export default ResultVerificationMayor;
